// eslint-disable-line max-lines
import React from 'react';
import {createData} from '../../utils/createData';
import {parseArrToGridExcel} from '../../utils/parse';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import _ from 'lodash';
import {connect} from 'react-redux';
import moment from 'moment';
import {dateFormat, headerOffset, modelOffset, getReadCondition} from '../../utils/static';
import {dealerListForForcastSale} from '../../../common/constants/lists';
import {renderHeader, renderTable, renderWeekUndefinedMessage} from './render';

const date = new Date();
const currentYear = parseInt(moment(date).format('YYYY'), 10);
const currentMonth = parseInt(moment(date).format('MM'), 10);
const WIDTH = 100;

const INITIAL_STATE = {
  'data': [],
  'weeks': [],
  'dealer': '',
  'agencies': [],
  'models': [],
  'yearFilter': currentYear,
  'monthFilter': currentMonth,
  'localWeekSaleForecast': [],
  'filteredTableByWeek': false,
  'filteredTableByAgency': false,
  'editionDisabled': true,
  'searchClicked': false,
};

class Spread extends React.Component {
  constructor(props) {
    super(props);
    INITIAL_STATE.rucFilter = props.isUserFromTDE ? dealerListForForcastSale[0].value : props.userLoggedDealerId;

    this.handleCellsChange = this.handleCellsChange.bind(this);
    this.renderCellContent = this.renderCellContent.bind(this);
    this.handleFilterSelection = this.handleFilterSelection.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.renderFilteredData = this.renderFilteredData.bind(this);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    this.props.clearSaleForecast();
    const {isUserFromTDE, salesType} = this.props;
    const {yearFilter, monthFilter} = this.state;
    this.setDataGrid();

    if (isUserFromTDE) {
      this.props.fetchVehiclesModel();
      this.props.fetchSalesForecastByDealers(this.getSalesTypeCode(salesType), yearFilter, monthFilter);
      return;
    }
    this.handleSearchClick();
  }

  getSalesTypeCode = (salesType) => {
    return salesType === 'normales' ? 'N' : 'E';
  }

  setDataGrid(callbackFunction = null) {
    const {models, agencies, weeks, editionDisabled} = this.state;
    this.setState({
      'data': parseArrToGridExcel(
        createData(models, agencies, weeks),
        weeks.length + modelOffset, editionDisabled
      ),
    }, callbackFunction);
  }

  generateWeeksArray() {
    return this.props.dates.map((date) => {
      const startDateMoment = moment(date.startDate, dateFormat);
      const endDateMoment = moment(date.endDate, dateFormat);
      return `${startDateMoment.format('D')} - ${endDateMoment.format('D')} ${startDateMoment.format('MMMM')}`;
    });
  }

  generateAgenciesArray() {
    return this.props.agenciesList.map((agency) => {
      return agency.name;
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.weekSaleForecast !== prevProps.weekSaleForecast) {
      this.setState({'localWeekSaleForecast': this.props.weekSaleForecast}, () => {
        this.refreshData();
      });
    }

    if (this.props.vehicles !== prevProps.vehicles) {
      const updatedModels = this.props.vehicles.map((vehicle) => {
        return {'name': vehicle.name, 'id': vehicle.id};
      });
      this.setState({'models': updatedModels}, () => {
        const searchWeeks = this.props.dates.map((date) => {
          return date.id;
        }).join();
        const {rucFilter} = this.state;
        const {salesType} = this.props;
        if (rucFilter !== dealerListForForcastSale[0].value) {
          this.props.fetchSaleForecast(this.getSalesTypeCode(salesType), rucFilter, searchWeeks);
        }
      });
    }

    if (this.props.dates !== prevProps.dates) {
      this.setState({'weeks': this.generateWeeksArray()});
    }

    if (!_.isEqual(this.props.agenciesList, prevProps.agenciesList) ||
    (this.props.agenciesList.length > 0 && this.state.agencies.length === 0)) {
      this.setState({'agencies': this.generateAgenciesArray()});
    }

    if (prevState.weeks !== this.state.weeks ||
      prevState.agencies !== this.state.agencies ||
      prevState.models !== this.state.models) {
      this.setDataGrid(this.renderFilteredData);
    }

    if (prevState.filteredTableByWeek !== this.state.filteredTableByWeek ||
      prevState.filteredTableByAgency !== this.state.filteredTableByAgency) {
      if (!this.state.filteredTableByWeek && !this.state.filteredTableByAgency) {
        this.handleSearchClick();
      }
    }
  }

  refreshData(parsedData = null) {
    const {agenciesList, dates, vehicles} = this.props;
    const {
      data, localWeekSaleForecast, weeks, filteredTableByWeek, filteredTableByAgency, editionDisabled,
    } = this.state;
    let dataCopy = _.cloneDeep(data);
    const weekArrayLength = weeks.length;
    const dataSource = parsedData ? parsedData : localWeekSaleForecast;
    dataSource.forEach((element) => {
      const agencyIndex = agenciesList.indexOf(
        agenciesList.find((agency) => {
          return agency.code === element.agency;
        })
      );
      const dateIndex = dates.indexOf(
        dates.find((date) => {
          return date.id === element.weekId;
        })
      );
      const columnOffset = filteredTableByWeek ? 0 : 1;
      
      let columnShift = weekArrayLength * agencyIndex + dateIndex + agencyIndex;
      if (filteredTableByWeek && filteredTableByAgency) {
        columnShift = 1;
      } else if (filteredTableByWeek) {
        columnShift = 2 * agencyIndex + 1;
      } else if (filteredTableByAgency) {
        columnShift = dateIndex;
      }

      const columnIndex = columnOffset + columnShift;
      const rowIndex = vehicles.indexOf(
        vehicles.find((vehicle) => {
          return vehicle.id === element.vehicleModel;
        })) + headerOffset;
      if (dataCopy.length <= 3) {
        return;
      }
      if (rowIndex >= headerOffset) {
        dataCopy[rowIndex][columnIndex] = {'value': element.quantity, 'readOnly': editionDisabled, 'width': WIDTH};
      }
    });

    dataCopy = this.getAgencyTotals(dataCopy);
    dataCopy = this.getWeekTotals(dataCopy);
    this.setState({'data': dataCopy});
  }

  renderFilteredData() {
    const {filteredTableByAgency, filteredTableByWeek} = this.state;
    if (!filteredTableByAgency && !filteredTableByWeek) {
      return;
    }
    const {data, localWeekSaleForecast} = this.state;
    const formattedData = this.formatData(data);
    const parsedData = [];
    formattedData.forEach((element) => {
      const recordInLocalCopy = localWeekSaleForecast.find((record) => {
        return record.agency === element.agency && record.customerId === element.customerId &&
        record.vehicleModel === element.vehicleModel && record.weekId === element.weekId;
      }) || element;
      parsedData.push(recordInLocalCopy);
    });

    const isDataValid = parsedData.some((data) => {
      return !!data;
    });
    if (!isDataValid) {
      return;
    }
    this.refreshData(parsedData);
  }

  render() {
    const {yearFilter, monthFilter, rucFilter, searchClicked, dealer, data} = this.state;
    const {loading, saving, isUserFromTDE, dates, agenciesList, salesType} = this.props;
    return (
      <div className="app">
        {renderHeader({
          'yearFilter': yearFilter,
          'monthFilter': monthFilter,
          'rucFilter': rucFilter,
          'loading': loading,
          'saving': saving,
          'renderSaveButton': this.renderSaveButton.bind(this),
          'handleSearchClick': this.handleSearchClick.bind(this),
          'handleFilterSelection': this.handleFilterSelection.bind(this),
          'getDealers': this.getDealers.bind(this),
          'salesType': salesType,
        })
        }
        {renderTable({
          'rucFilter': rucFilter,
          'isUserFromTDE': isUserFromTDE,
          'dealer': dealer,
          'data': data,
          'dates': dates,
          'loading': loading,
          'agenciesList': agenciesList,
          'renderCellContent': this.renderCellContent.bind(this),
          'handleCellsChange': this.handleCellsChange.bind(this),
        })}
        {renderWeekUndefinedMessage({
          'dates': dates,
          'rucFilter': rucFilter,
          'yearFilter': yearFilter,
          'monthFilter': yearFilter,
          'searchClicked': searchClicked,
        })}
      </div>
    );
  }

  renderSaveButton() {
    const {editionDisabled, yearFilter, monthFilter, rucFilter, data} = this.state;
    const {loading, saving} = this.props;
    if (editionDisabled) {
      return null;
    }
    return (
      <Button primary
        disabled={!yearFilter || !monthFilter || !rucFilter || data.length <= 3 || loading || saving}
        onClick={this.handleSaveClick}
      >
      Guardar
      </Button>
    );
  }

  handleFilterSelection(event, data) {
    const {name, value} = data;
    const updatedState = _.cloneDeep(this.state);
    updatedState[name] = value;
    updatedState.editionDisabled = true;
    updatedState.data = [];
    this.setState(updatedState);
    this.props.clearSaleForecast();
  }

  getDealers() {
    const {isUserFromTDE, userLoggedDealerId} = this.props;
    if (isUserFromTDE) {
      return dealerListForForcastSale;
    }
    return _.filter(dealerListForForcastSale, {'value': userLoggedDealerId});
  }

  handleSearchClick() {
    const {rucFilter, yearFilter, monthFilter} = this.state;
    const {dates, isUserFromTDE, userLoggedDealerId, salesType} = this.props;
    if (!isUserFromTDE && rucFilter === dealerListForForcastSale[0].value) {
      return;
    }
    if (isUserFromTDE && rucFilter === dealerListForForcastSale[0].value) {
      this.props.fetchSalesForecastByDealers(this.getSalesTypeCode(salesType), yearFilter, monthFilter);
      return;
    }
    
    const dealerName = dealerListForForcastSale.find((dealer) => {
      return dealer.value === rucFilter;
    }).text;
    this.props.fetchAgenciesByDealer(
      {
        'dealerId': rucFilter,
        'yearFilter': yearFilter,
        'monthFilter': monthFilter,
        'salesReport': 'S',
      }
    );
    const searchWeeks = dates.map((date) => {
      return date.id;
    }).join();
    
    this.props.fetchSaleForecast(this.getSalesTypeCode(salesType), rucFilter, searchWeeks);
    
    this.setState({
      'dealer': dealerName,
      'filteredTableByWeek': false,
      'editionDisabled': isUserFromTDE ? false :
        getReadCondition({userLoggedDealerId, rucFilter, yearFilter, monthFilter}),
      'searchClicked': true,
    });
  }

  handleSaveClick() {
    const {data} = this.state;
    const dataToSave = this.formatData(data);
    this.props.saveSaleForecastData(dataToSave).then(() => {
      this.renderFilteredData();
    });
  }

  formatData(data) {
    const formattedData = [];
    if (data.length < 2) {
      return formattedData;
    }
    for (let i = 2; i < data.length; i++) {
      const vehicleModel = this.props.vehicles.find((vehicle) => {
        return vehicle.id === data[i][0].id;
      });
      for (let j = 1; j < data[0].length; j ++) {
        const agency = this.props.agenciesList.find((agency) => {
          return agency.name === data[0][j].value;
        });
        const week = this.props.dates.find((date) => {
          const startDateMoment = moment(date.startDate, dateFormat);
          const endDateMoment = moment(date.endDate, dateFormat);
          return `${startDateMoment.format('D')} - ${endDateMoment.format('D')} ${startDateMoment.format('MMMM')}` ===
          data[1][j].value;
        });
        const weekCode = week ? week.id : '';
        const vehicleModelCode = vehicleModel ? vehicleModel.id : '';
        const agencyCode = agency ? agency.code : '';
        if (weekCode && agencyCode && vehicleModelCode && weekCode) {
          formattedData.push({
            'customerId': this.state.rucFilter,
            'agency': agencyCode,
            'vehicleModel': vehicleModelCode,
            'weekId': weekCode,
            'quantity': parseInt(data[i][j].value, 10),
            'salesType': this.getSalesTypeCode(this.props.salesType),
          });
        }
      }
    }
    return formattedData;
  }

  renderCellContent(cell, i, j) {
    if (cell.readOnly) {
      this.handleHeaderDoubleClick.bind(this, cell, i, j);
      return (
        cell.value
      );
    }
    return cell.value;
  }

  handleHeaderDoubleClick(cell, i, j) {
    const {agencies, weeks, filteredTableByAgency, filteredTableByWeek} = this.state;
    if (i === 0) {
      const agenciesCopy = _.cloneDeep(agencies);
      
      const updatedAgencies = !filteredTableByAgency ? this.getFilteredArray(agenciesCopy, cell) :
        this.generateAgenciesArray();

      this.setState({'agencies': updatedAgencies, 'filteredTableByAgency': !filteredTableByAgency});
    }

    if (i === 1 && cell.value !== 'TOTAL') {
      const weeksCopy = _.cloneDeep(weeks);
      const updatedWeeks = !filteredTableByWeek ? this.getFilteredArray(weeksCopy, cell) :
        this.generateWeeksArray();

      this.setState({'weeks': updatedWeeks, 'filteredTableByWeek': !filteredTableByWeek});
    }
  }

  handleCellsChange(changes) {
    const {data} = this.state;
    const dataCopy = _.cloneDeep(data);
    changes.forEach(({row, col, value}) => {
      const validatedValue = this.validateRawData(value);
      dataCopy[row][col] = {...dataCopy[row][col], 'value': validatedValue};
    });
    const dataToUpdate = this.getTotals(dataCopy);
    this.setState({'data': dataToUpdate});
  }

  getTotals(data) {
    const dataCopy = _.cloneDeep(data);
    const dataWithAgencyTotals = this.getAgencyTotals(dataCopy);
    const dataWithWeekTotals = this.getWeekTotals(dataWithAgencyTotals);
    return dataWithWeekTotals;
  }

  getAgencyTotals(data) {
    const updatedData = _.cloneDeep(data);
    const {weeks, agencies} = this.state;
    for (let i = 2; i < updatedData.length; i++) {
      const row = updatedData[i];
      for (let j = 1; j < (weeks.length + 1) * agencies.length; j += (weeks.length + 1)) {
        const weekArray = row.slice(j, j + weeks.length);
        const partialSum = weekArray.reduce((accumulator, currentValue) => {
          return accumulator + Number(currentValue.value);
        }, 0);
        updatedData[i][j + weeks.length] = {...updatedData[i][j + weeks.length], 'value': partialSum};
      }
    }
    return updatedData;
  }

  getWeekTotals(data) {
    const updatedData = _.cloneDeep(data);
    const {models, weeks, agencies, rucFilter, yearFilter, monthFilter} = this.state;
    if (!weeks.length && rucFilter && yearFilter && monthFilter) {
      return [];
    }
    for (let i = 1; i <= (weeks.length + 1) * agencies.length; i++) {
      const column = updatedData.map((cell) => {
        return cell[i];
      }).filter((cell, index) => {
        return cell && Number.isInteger(cell.value) && index < models.length + headerOffset;
      });
      const columnSum = column.reduce((accumulator, currentValue) => {
        return accumulator + Number(currentValue.value);
      }, 0);
      updatedData[models.length + headerOffset][i] = {
        ...updatedData[models.length + headerOffset][i], 'value': columnSum,
      };
    }
    return updatedData;
  }

  validateRawData(rawInput) {
    const parsedValue = Number(rawInput);
    return !parsedValue || isNaN(parsedValue) || parsedValue < 0 || !Number.isInteger(parsedValue) ? '0' : parsedValue;
  }

  getFilteredArray(stateArray, cell) {
    return stateArray.filter((item) => {
      return item === cell.value;
    });
  }
}

const mapStateToProps = (state) => {
  const agencies = state.dealer.agenciesList.filter((agency) => {
    return agency.subjectToVehicleKpi === 'S';
  });
  return {
    'permissions': state.session.permissions,
    'vehicles': state.vehiclesModels.vehicles,
    'dates': state.budgets.manageDates,
    'agenciesList': _.orderBy(agencies, ['name']),
    'saving': state.saleForecast.saving,
    'loading': state.saleForecast.loading,
    'weekSaleForecast': state.saleForecast.list,
    'isUserFromTDE': state.session.isUserFromTDE,
    'userLoggedDealerId': state.session.dealerId,
  };
};

const {
  fetchVehiclesModel,
  fetchBudgetsDates,
  fetchAgenciesByDealer,
  fetchSaleForecast,
  clearSaleForecast,
  saveSaleForecastData,
  addMessageBoxWarning,
  fetchSalesForecastByDealers,
} = Actions;

export default connect(mapStateToProps, {
  fetchVehiclesModel,
  fetchBudgetsDates,
  fetchAgenciesByDealer,
  fetchSaleForecast,
  clearSaleForecast,
  saveSaleForecastData,
  addMessageBoxWarning,
  fetchSalesForecastByDealers,
})(Spread);
